type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
};

export const SEARCHCASE_HEADERS: Header[] = [
  //{key: 'customerAccountNo', label: 'Patient Account No', sortable: true, style: {width: '13%'}},
  {
    key: 'subjectFullName',
    label: 'Patient Full Name',
    sortable: true,
    style: {width: '15%'},
  },
  
  // {
  //   key: 'dateOfExam',
  //   label: 'Date Of Exam',
  //   sortable: true,
  //   style: {width: '12%'},
  // },
  {
    key: 'casePriorityDesc',
    label: 'Priority',
    sortable: true,
    style: {width: '6%'},
  },
  {
    key: 'caseTypeDesc',
    label: 'Case Type',
    sortable: true,
    style: {width: '11%'},
  },
  {
    key: 'masterClaimNumber',
    label: 'Claim No',
    sortable: true,
    style: {width: '10%'},
  },
  {
    key: 'locationOfExam',
    label: 'Location Of Exam',
    sortable: true,
    style: {width: '12%'},
  },
  {
    key: 'qmeDoctorName',
    label: 'Doctor Name',
    sortable: true,
    style: {width: '12%'},
  },
  
  {
    key: 'caseSubjectDOB',
    label: 'Date Of Birth',
    sortable: true,
    style: {width: '7%'},
  },
  {
    key: 'caseStageName',
    label: 'Case Stage',
    sortable: true,
    style: {width: '7%'},
  },
  {
    key: 'actions',
    label: 'Action',
    style: {width: '5%'},
  },
];
